import { TOKEN_CONSTANTS } from 'constant';
import { getLocalStorage } from 'helpers/localstorage-utils';
import { Container } from 'react-bootstrap';
import { Navigate, Outlet } from 'react-router-dom';

const AssessmentLayout = () => {
  const token = getLocalStorage(TOKEN_CONSTANTS.QUIZ);

  return token ? (
    <Container fluid className="px-0">
      <Outlet />
    </Container>
  ) : (
    <Navigate to="/home/ladder/basic" />
  );
};

export default AssessmentLayout;
